import { storageRef, firestoreRef, authRef } from 'api';

export async function uploadImageToStorage(image, imageName) {
  const snapshot = await storageRef
    .child(`profile/images/${imageName}`)
    .put(image);
  return snapshot.ref.getDownloadURL();
}
export async function updateProfileData(userId, formData) {
  return await firestoreRef
    .collection('users')
    .doc(userId)
    .update(formData);
}

export function isVerified() {
  if (authRef.currentUser.emailVerified) {
    return true;
  } else {
    return false;
  }
}

export async function getTransactions(limit) {
  const user = authRef.currentUser;

  const query = firestoreRef
    .collection('transactions')
    .where('uid', '==', user.uid)
    .orderBy('date', 'desc');
  let result;
  if (limit) result = await query.limit(limit).get();
  else result = await query.get();

  return result.docs.map(d => d.data());
}
